import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileBar, FloatingWhatsApp } from "./MobileBar";
import { SmoothScroll } from "./SmoothScroll";
import { SiteSchema } from "./Seo";

export const Layout = () => (
  <MotionConfig reducedMotion="user">
    <SiteSchema />
    <SmoothScroll />
    <Header />
    <main id="main" className="min-h-screen">
      <Suspense fallback={<div className="min-h-screen" aria-hidden />}><Outlet /></Suspense>
    </main>
    <div className="pb-[84px] md:pb-0 bg-sand">
      <Footer />
    </div>
    <MobileBar />
    <FloatingWhatsApp />
  </MotionConfig>
);
